import {
  normalizeCartLines,
  type NormalizedCartLine,
  type TemperaturePreference
} from '../features/cart/utils/cartNormalization';

const CART_STORAGE_KEY = 'ninpo:cart';

type CartLine = {
  id: string;
  productId?: string;
  quantity: number;
  temperaturePreference?: TemperaturePreference | 'cold' | 'either';
};

export const normalizeStoredCart = (raw: unknown): CartLine[] =>
  normalizeCartLines(raw).map(({ id, productId, quantity, temperaturePreference }) => ({
    id,
    productId,
    quantity,
    temperaturePreference
  }));

export const readStoredCart = () => {
  if (typeof window === 'undefined') return [] as CartLine[];
  const stored = window.localStorage.getItem(CART_STORAGE_KEY);
  if (!stored) return [] as CartLine[];
  try {
    return normalizeStoredCart(JSON.parse(stored));
  } catch {
    return [] as CartLine[];
  }
};

export const persistCart = (next: Array<Partial<NormalizedCartLine> | CartLine>) => {
  if (typeof window === 'undefined') return false;
  try {
    window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(normalizeStoredCart(next)));
    return true;
  } catch {
    return false;
  }
};
